// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.feedtomanual.RentalManagerUserPropertyFeedToManualV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyFeedToManualV2WebApiHandler_convert } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyFeedToManualConvertRequestDto,
  UserPropertyFeedToManualConvertV2ResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyFeedToManualV2WebApiHandler_convert_Args {
  postData: UserPropertyFeedToManualConvertRequestDto;
}

export type RentalManagerUserPropertyFeedToManualV2WebApiHandler_convert_Options = UseMutationOptions<
  UserPropertyFeedToManualConvertV2ResponseWebDto,
  unknown,
  RentalManagerUserPropertyFeedToManualV2WebApiHandler_convert_Args
>;

/**
 * Convert a feed listing to manual listing
 */
export const useRentalManagerUserPropertyFeedToManualV2WebApiHandler_convert = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFeedToManualV2WebApiHandler_convert_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFeedToManualV2WebApiHandler_convert_Args) =>
      RentalManagerUserPropertyFeedToManualV2WebApiHandler_convert(args.postData, httpClient),
  });
};
